import { StripeError } from '@stripe/stripe-js';
import { TFunction } from 'i18next';

import { StripeDeclineErrorCodes, StripeErrorCodes } from 'constants/enums';

export const getSetupIntentPaymentErrorDescription = (
  error: StripeError,
  t: TFunction
): string => {
  switch (error.code) {
    case StripeErrorCodes.ExpiredCard:
      return t('error.message.cardExpired');
    case StripeErrorCodes.CardDeclined:
      return error.decline_code === StripeDeclineErrorCodes.InsufficientFunds
        ? t('error.message.insufficientFunds')
        : error.message ?? '';
    default:
      return error.message ?? '';
  }
};
